import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-status-tracker',
	templateUrl: './status-tracker.component.html',
	styleUrl: './status-tracker.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [NgClass, NgIf, NgFor, TranslateModule]
})
export class PrototypeStatusComponent {
	@Input() statuses!: string[];
	@Input() currentIndex!: number;
}
